import { Button, Flex, Form, FormInstance, Input } from "antd";
import { useEffect } from "react";
import AddIcon from "../../../../../assets/icons/AddIcon";
import PencilLine from "../../../../../assets/icons/PencilLine";
import CustomDrawer from "../../../../../components/ui/CustomDrawer";
import FileUpload from "../../../../../components/ui/FileUpload";
import useModal from "../../../../../hooks/useModal";

type Props = { form: FormInstance<any> };

const InvoiceDocuments = ({ form }: Props) => {
  const [docForm] = Form.useForm();

  const { open, handleOpen, handleClose } = useModal<{ index: number }>();

  // ------ Watched values ------
  const documents = Form.useWatch("documents", form);
  const selectedDoc = documents?.[open.data?.index as number];

  // ------ Function for add/update business documents ------
  const handleDocSave = (values: Record<string, unknown>) => {
    const index = open?.data?.index;
    const currentList = documents ?? [];
    let updatedList = [...currentList];

    if (typeof index === "number") {
      // Update existing bank info
      updatedList = currentList.map((item: any, i: number) =>
        i === index ? { ...item, ...values } : item,
      );
    } else {
      // Add new bank info
      updatedList = [...currentList, values];
    }

    form.setFieldsValue({ documents: updatedList });
    handleClose();
  };

  useEffect(() => {
    docForm.setFieldsValue(selectedDoc);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, docForm]);
  return (
    <Form.List
      name={"documents"}
      initialValue={[
        { document_name: "Delivery Challan", document_url: undefined },
        { document_name: "Trader License", document_url: undefined },
      ]}
    >
      {(fields, { add, remove }) => {
        const filteredDocs = documents?.filter(
          (item: any) => item !== undefined,
        );
        return (
          <div>
            <Flex justify="space-between" className="mb-5">
              <h5 className="text-lg text-theme-gray-2 font-semibold">
                Vendor Contacts
              </h5>
              <Button
                size="small"
                htmlType="button"
                className="button-primary-light min-w-20"
                onClick={() => {
                  add();
                  handleOpen({
                    type: "ADD",
                    data: { index: fields?.length || 0 },
                  });
                }}
              >
                <AddIcon /> Add Field
              </Button>
            </Flex>
            <div className="grid grid-cols-2 gap-x-4 p-5 rounded-xl border border-theme-indigo-50">
              {filteredDocs?.length
                ? fields.map(({ key, name, ...restField }, index) => {
                    if (documents?.[name] === undefined) {
                      return null;
                    }
                    const labelValue = form.getFieldValue([
                      "documents",
                      index,
                      "document_name",
                    ]);
                    return (
                      <div>
                        <Form.Item
                          {...restField}
                          name={[name, "file"]}
                          rootClassName="full-label"
                          label={
                            <Flex justify="space-between" className="!w-full">
                              <span>{labelValue}</span>
                              <button
                                onClick={() => {
                                  handleOpen({
                                    type: "UPDATE",
                                    data: { index: name || 0 },
                                  });
                                }}
                                type="button"
                                className="cursor-pointer"
                              >
                                <PencilLine />
                              </button>
                            </Flex>
                          }
                        >
                          <FileUpload
                            accept=".png,.jpeg,.jpg,.pdf"
                            form={form}
                            name={[name, "document_url"] as unknown as string}
                            description="PDF, JPG, PNG (Max 5MB)"
                          />
                        </Form.Item>
                      </div>
                    );
                  })
                : null}
            </div>

            <CustomDrawer
              title="Add More"
              open={open.open}
              onClose={() => {
                open.type === "ADD" && remove(open.data?.index as number);
                docForm.resetFields();
                handleClose();
              }}
            >
              <Form
                className="custom-form"
                layout="vertical"
                // requiredMark="optional"
                size="large"
                form={docForm}
                onFinish={(values) => {
                  handleDocSave(values);
                  docForm.resetFields();
                }}
              >
                <Form.Item
                  rootClassName="mb-2"
                  label="Document Name"
                  name="document_name"
                  rules={[
                    {
                      required: true,
                      message: "Please enter document name",
                    },
                  ]}
                >
                  <Input placeholder="Enter document name" />
                </Form.Item>

                <Form.Item rootClassName="mb-2" label="Attachment" name="file">
                  <FileUpload
                    placeholder="Choose file"
                    description="PDF, JPG, PNG (Max 5MB)"
                    name="document_url"
                    form={docForm}
                  />
                </Form.Item>
                <Flex gap={16} justify="end">
                  <Button
                    onClick={() => {
                      open.type === "ADD" && remove(open.data?.index as number);
                      docForm.resetFields();
                      handleClose();
                    }}
                    size="small"
                    className="button-white-bordered"
                    htmlType="button"
                  >
                    Cancel
                  </Button>
                  <Button
                    size="small"
                    htmlType="button"
                    className="button-primary min-w-20"
                    onClick={() => {
                      docForm.submit();
                    }}
                  >
                    Save
                  </Button>
                </Flex>
              </Form>
            </CustomDrawer>
          </div>
        );
      }}
    </Form.List>
  );
};

export default InvoiceDocuments;
